import { Component } from '@angular/core';
import { ChartDataset } from 'chart.js';
import { GRAPH_PANEL_IMPORTS, GraphPanelComponent } from 'src/app/panels/components/graph-panel/graph-panel.component';
import { PanelComponent } from 'src/app/panels/components/panel.component';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { GenerateGraphDataset, GraphType, IGraphConfig, IGraphMappedDataset } from 'src/app/panels/models/graph';
import { PanelType } from 'src/app/panels/models/panel-type';
import { Color } from 'src/app/shared/services/color/colors';

@PanelComponent.register
@Component({
  templateUrl: '../../../../panels/components/graph-panel/graph-panel.component.html',
  styleUrl: '../../../../panels/components/graph-panel/graph-panel.component.scss',
  selector: 'app-air-temperature-graph-panel',
  imports: GRAPH_PANEL_IMPORTS,
})
export class AirTemperatureGraphPanelComponent extends GraphPanelComponent {
  public static override readonly type = PanelType.AirTemperatureGraph;
  public override small = true;
  protected override unit = DisplayUnit.DegreeCelsius;

  protected override graphInfo = {
    title: 'Luchttemperatuur grafiek',
    description: `
      <p>
        Deze grafiek toont de luchttemperatuur van het geselecteerde meetpunt in graden Celsius.
        In de live-weergave zie je de actuele temperatuur. Voor dag- en maandweergave wordt het gemiddelde van de meetpunten getoond.
      </p>
    `,
  };

  protected override config: IGraphConfig = { getGraphTypeDataset: this.getGraphTypeDataset };

  private getGraphTypeDataset(
    generateDataset: GenerateGraphDataset,
    dataset: IGraphMappedDataset,
    startTimestamps: string[],
    endTimestamps: string[],
  ): ChartDataset {
    switch (dataset.type) {
      case GraphType.ClimateAirTemperature:
        return generateDataset(
          dataset,
          startTimestamps,
          endTimestamps,
          'Temperatuur',
          Color.Blue,
          DisplayUnit.DegreeCelsius,
          'line',
        );
      default:
        throw new Error(`No dataset specified for GraphType '${dataset.type}'`);
    }
  }
}
